module.exports = __webpack_public_path__ + "img/ts6.a4c2a1b1.png";